export const sql_mas_ct = `


SELECT COUNT(*) TotalCustomer FROM MAS_CT 
SELECT COUNT(*) NewCustomerOfMonth FROM MAS_CT WHERE YEAR(RegisDate) = YEAR(Getdate()) AND MONTH(RegisDate) = MONTH(Getdate())

`